import {createStore} from 'vuex'

const store = createStore({
	state(){
		return {
			filters:[],
			filterValues:[],
			data:[],
			selected:{},
			startCounting:false,
			resultCount:0,
			results:[]
		}
	},
	mutations: {
		filterValues(state,payload){
			state.filterValues = payload;
		},
		filters(state,payload){
			state.filters = payload;
		},
		data(state,payload){
			state.data = payload;
		},
		selected(state,payload){
			state.selected[payload.name] = payload.value;
			state.results = [];
		},
		resetSelected(state){
			state.selected = {};
		},
		startCounting(state,payload){
			state.startCounting = payload;
		},
		resultCount(state,payload){
			state.resultCount = payload;
		},
		results(state,payload){
			state.results = payload;
		}
	},
	getters:{
		filters(state){
			return state.filters;
		},
		filterValue: (state) => (payload) => {
			return state.filterValues[payload];
		},
		filterValues(state) {
			return state.filterValues;
		},
		selectedValue: (state) => (payload) => {
			return state.selected[payload];
		},
		selectedValues(state){
			return state.selected;
		},
		startCounting(state){
			return state.startCounting;
		},
		resultCount(state){
			return state.resultCount;
		},
		results(state){
			return state.results;
		},
		ctaButton(state){
			return state.data.ctaButton;
		},
		url: (state) => (payload) => {
			//fetch current selected segment
			const segmentId = state.selected.segments;
			//filter the segment value set
			const segment = state.filterValues.segments.find(
				filter => filter.value === segmentId
			);
			//return the url part : count or result given from payload
			return segment[payload];
		},
	},
	actions:{
		select(context,payload){

			context.commit('selected',payload);

			if (payload.name === 'segments'){
				context.commit('startCounting',false);
				context.dispatch('resetForNewSegment',payload).then(() => {
					context.commit('startCounting',true);
					context.dispatch('countProducts');
					context.dispatch('fetchResults',context.getters.selectedValues);
				});
			} else {

				if (context.getters.startCounting){
					//fetch count and fetch new results
					context.commit('results',[]);
					context.dispatch('countProducts');
					context.dispatch('fetchResults',context.getters.selectedValues);
				}
			}

			return true;
		},
		resetForNewSegment(context,payload){
			context.commit('resetSelected');
			context.commit('selected',payload);

			const filterSet =  context.state.data.filterTypes.find(
				filterType => filterType.id === payload.value
			);

			const filterValues = context.state.data.segmentFilterValues.find(filter => filter.id === payload.value);

			filterValues['segments'] = context.state.data.segments;

			if (typeof filterValues != 'undefined' && typeof filterSet != 'undefined'){
				context.commit('filterValues',filterValues);
				context.commit('filters',filterSet.filter);
			}
		},
		fetchFilterValues(context){

			const currentUrl = document.getElementById('fetchUri').value;

			fetch(currentUrl)
				.then((response)=>{
					if (response.ok) {
						return response.json();
					}
				})
				.then((data)=>{

					context.commit('data',data);

					return data;

				}).then(function (data) {
					//preselect first segment
					const segment = data.segments[0];
					context.commit('selected',{name:'segments',value:segment.value});

					return {data:data,segment:segment};

				}).then(function (dataSet){

					const filterSet =  dataSet.data.filterTypes.find(
						filterType => filterType.id === dataSet.segment.value
					);

					const filterValues = context.state.data.segmentFilterValues.find(
						filter => filter.id === dataSet.segment.value
					);

					filterValues['segments'] = dataSet.data.segments;

					context.commit('filterValues',filterValues);
					context.commit('filters',filterSet.filter);

					if (typeof dataSet.data.showResults != 'undefined'){
						return dataSet.data.showResults;
					} else {
						return false;
					}

				}).then(function (showResults){
					context.commit('startCounting',true);
					context.dispatch('countProducts');

					if (showResults){
						context.dispatch('countProducts');
						context.dispatch('fetchResults',context.getters.selectedValues);
					}
			});
		},
		fetchResults(context,payload){
			const modal = document.getElementById('modal-filter');
			let currentUrl = document.getElementById('baseUri').value;
			currentUrl+= context.getters.url('result');

			//fetch detail pid for products
			payload.detailPid = document.getElementById('detailPid').value;

			//show modal overlay
			modal.classList.add("show");

			fetch(currentUrl,
				{
					method:'POST',
					headers:{
						'Content-Type':'application/x-www-form-urlencoded'
					},
					body:'tx_ccmpimfrontend_api[query]='+JSON.stringify(payload)
				}
			).then((response)=>{
				if (response.ok) {
					return response.json();
				}
			}).then((data)=>{
				context.commit('results',data);
				//hide modal overlay
				modal.classList.remove("show");
			});
		},
		countProducts(context){

			let currentUrl = document.getElementById('baseUri').value;
			currentUrl+= context.getters.url('count');

			const postRequest = JSON.stringify(context.getters.selectedValues);

			fetch(currentUrl,
				{
					method:'POST',
					headers:{
						'Content-Type':'application/x-www-form-urlencoded'
					},
					body:'tx_ccmpimfrontend_api[query]='+postRequest
				}
			).then((response)=>{
				if (response.ok) {
					return response.json();
				}
			}).then((data)=>{
				context.commit('resultCount',data);
			});
		}
	},
});



export default store;
